import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Form, Input, Radio, Space } from 'antd';
import * as _ from 'lodash';
import UserPicker from '../UserPicker';

const NotificationForm = ({restrictNotificationList}) => {

  const [form] = Form.useForm();

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };

  return (
    <Container id="notification-container">
      <Form
        form={form}
        layout="vertical"
        labelAlign="left"
        name="notificationForm"
        {...formItemLayout}
        initialValues={{messageOption: '2', notificationList: [], notificationSubject: '', notificationMessage: ''}}
        style={{width: '100%', height: '100%'}}
      >
        <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
          <Form.Item name="notificationList" label="To">
              <UserPicker includeGroups={true} restrictUsers={restrictNotificationList} />
          </Form.Item>
          <Form.Item name="notificationSubject" label="Subject">
            <Input />
          </Form.Item>
          <Form.Item name="notificationMessage" className="message-box" label="Message" style={{flex: '1'}}>
            <Input.TextArea style={{resize: 'none', height: "100%"}} />
          </Form.Item>
          <Form.Item name="messageOption">
            <Radio.Group>
                <Space direction="vertical">
                  <Radio value="0">Send message with no file information</Radio>
                  <Radio value="1">Send one message for each file</Radio>
                  <Radio value="2">Send one message for all files</Radio>
                </Space>
            </Radio.Group>
          </Form.Item>
        </div>
      </Form>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  .ant-space {
    gap: 0 !important;
  }
  .ant-form-item {
    margin: 5px 0;
  }
  .message-box .ant-row {
    display: block;
    height: 100%;
  }
  .message-box .ant-row div:nth-child(2) {
    height: calc(100% - 25px);
  }
  .message-box .ant-row div:nth-child(2) div {
    height: 100%;
  }
`

const mapStateToProps = state => {
  const { restrictNotificationList } = state.app;
  return { restrictNotificationList };
};

export default connect(mapStateToProps)(NotificationForm);